import React from 'react'

import Decklist from 'components/decklists/DeckListWithMetaData'

export const AugustTrainwreck: React.FC = () => {
  return (
    <Decklist
      name="August Trainwreck"
      drafter="Parker LaMascus"
      description={
        <>Featuring a cool 15 lands. Read &rsquo;em and weep... for me.</>
      }
      maindeck={[
        [
          { name: 'Rakdos Carnarium', set: 'DIS' },
          { name: 'Orzhov Basilica', set: 'GPT' },
          { name: 'Snow-Covered Island', set: 'CSP' },
          { name: 'Snow-Covered Forest', set: 'CSP' },
          { name: 'Vivid Creek', set: 'LRW' },
          { name: 'Grove of the Burnwillows', set: 'FUT' },
          { name: 'Temple of Abandon', set: 'THS' },
          { name: 'Tendo Ice Bridge', set: 'BOK' },
          { name: 'Arcane Sanctum', set: 'ALA' },
          { name: 'Boros Garrison' },
          { name: 'Snow-Covered Mountain', set: 'CSP' },
          { name: 'Terramorphic Expanse' },
          { name: 'Cloudpost', set: 'MRD' },
          { name: 'Piranha Marsh' },
          { name: 'Ancient Den', set: 'MRD' },
        ],
        [
          { name: 'Thoughtseize', set: 'THS' },
          { name: "Arcum's Astrolabe", set: 'MH1' },
          { name: 'Greater Gargadon', set: 'TSP' },
          { name: 'Rimebound Dead', set: 'CSP' },
        ],
        [
          { name: 'Into the North', set: 'CSP' },
          { name: 'Break the Ice', set: 'MH2' },
          { name: 'Manamorphose', set: 'SHM' },
          { name: 'Delay' },
          { name: 'Kor Skyfisher', set: 'ZEN' },
          { name: 'Life From the Loam', set: 'RAV' },
          { name: 'Castigate', set: 'GPT' },
          { name: 'Howling Mine', set: 'C16' },
        ],
        [
          { name: 'Aether Tradewinds' },
          { name: 'Rend Flesh', set: 'CHK' },
          { name: 'Reality Acid', set: 'PLC' },
          { name: 'Ghost-Lit Raider', set: 'SOK' },
          { name: 'Pillory of the Sleepless', set: 'GPT' },
          { name: 'Curse of the Bloody Tome', set: 'ISD' },
        ],
        [
          { name: 'Grasp of Phantoms', set: 'ISD' },
          { name: 'Tolarian Sentinel', set: 'TSR' },
          { name: 'Annex', set: '9ED' },
          { name: 'Gifts Ungiven', set: 'CHK' },
        ],
        [
          { name: 'Traumatic Visions', set: 'CON' },
          { name: 'Seasons Past', set: 'SOI' },
          { name: 'Blasphemous Act', set: 'ISD' },
        ],
      ]}
    />
  )
}
